module.exports = __webpack_public_path__ + "static/media/slide-2.6e70e842.png";